"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchUserAttributes = fetchUserAttributes;
const utils_1 = require("@aws-amplify/core/internals/utils");
const fetchUserAttributes_1 = require("./internal/fetchUserAttributes");
async function fetchUserAttributes(...args) {
    const [ctx] = (0, utils_1.resolveCtxArgs)(args);
    return (0, fetchUserAttributes_1.fetchUserAttributes)(ctx);
}
